import { JetView } from 'webix-jet';
import { devConfig } from '../../../../config/config';

/**
 * SecurityForm class extends JetView to manage user security settings.
 */
export default class securityForm extends JetView {
    /**
     * Constructor for the SecurityForm class.
     * @param {Object} app - The application instance.
     * @param {string} name - The name of the view.
     * @param {Object} config - The configuration object.
     */
    constructor(app, name, config) {
        super(app, name, config);
        this.commentHistory = [];
    }

    /**
     * Fetches data related to the current user and updates the form fields accordingly.
     */
    getData() {
        const cur_user = this.getParam('user', true); // Get the current user ID
        webix.ajax().get(devConfig.geturlApi() + 'Client/GetClientById', 'id=' + cur_user, {
            error: function (text, data, XmlHttpRequest) {
                webix.message({
                    title: _('¡Mensaje!'),
                    type: 'alert-error',
                    text: _('Ocurrio un error.'),
                });
            },
            success: (text, data, XmlHttpRequest) => {
                text = JSON.parse(text); // Parse the response text
                let typesContingency = {}; // Object to hold contingency states

                // Update the state of various contingency switches based on the response
                if (text[0].IsActivateContingency === 'A') {
                    $$('StateContingencySwith').setValue(1);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencySwith: 1,
                    };
                } else {
                    $$('StateContingencySwith').setValue(0);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencySwith: 0,
                    };
                }
                if (text[0].IsActivateContingencyDeportivas === 'A') {
                    $$('StateContingencyDeportivasSwith').setValue(1);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyDeportivasSwith: 1,
                    };
                } else {
                    $$('StateContingencyDeportivasSwith').setValue(0);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyDeportivasSwith: 0,
                    };
                }
                if (text[0].IsActivateContingencyCasino === 'A') {
                    $$('StateContingencyCasinoSwith').setValue(1);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyCasinoSwith: 1,
                    };
                } else {
                    $$('StateContingencyCasinoSwith').setValue(0);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyCasinoSwith: 0,
                    };
                }
                if (text[0].IsActivateContingencyCasinoVivo === 'A') {
                    $$('StateContingencyCasinoVivoSwith').setValue(1);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyCasinoVivoSwith: 1,
                    };
                } else {
                    $$('StateContingencyCasinoVivoSwith').setValue(0);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyCasinoVivoSwith: 0,
                    };
                }
                if (text[0].IsActivateContingencyVirtuales === 'A') {
                    $$('StateContingencyVirtualesSwith').setValue(1);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyVirtualesSwith: 1,
                    };
                } else {
                    $$('StateContingencyVirtualesSwith').setValue(0);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyVirtualesSwith: 0,
                    };
                }
                if (text[0].IsActivateContingencyPoker === 'A') {
                    $$('StateContingencyPokerSwith').setValue(1);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyPokerSwith: 1,
                    };
                } else {
                    $$('StateContingencyPokerSwith').setValue(0);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyPokerSwith: 0,
                    };
                }
                if (text[0].IsActivateContingencyWithdrawal === 'A') {
                    $$('StateContingencyWithdrawalSwith').setValue(1);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyWithdrawalSwith: 1,
                    };
                } else {
                    $$('StateContingencyWithdrawalSwith').setValue(0);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyWithdrawalSwith: 0,
                    };
                }
                if (text[0].IsActivateContingencyDeposit === 'A') {
                    $$('StateContingencyDepositSwith').setValue(1);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyDepositSwith: 1,
                    };
                } else {
                    $$('StateContingencyDepositSwith').setValue(0);
                    typesContingency = {
                        ...typesContingency,
                        StateContingencyDepositSwith: 0,
                    };
                }

                // Store the types of contingency in local storage
                webix.storage.local.put('typesContingency', typesContingency);

                // Update the type lock based on the response
                if (text[0].IsActivateActive === 'A') {
                    $$('typeLock').setValue('Activated');
                    let checkboxes = [
                        'StateContingencySwith',
                        'StateContingencyDeportivasSwith',
                        'StateContingencyCasinoSwith',
                        'StateContingencyCasinoVivoSwith',
                        'StateContingencyVirtualesSwith',
                        'StateContingencyPokerSwith',
                        'StateContingencyWithdrawalSwith',
                        'StateContingencyDepositSwith',
                    ];
                    checkboxes.forEach((checkbox) => {
                        $$(checkbox).disable(); // Disable checkboxes
                    });
                    $$('Period').disable(); // Disable period field
                    $$('Period').hide(); // Hide period field
                    $$('periodSelect').setValue('Indefinido'); // Set period select to undefined
                    $$('periodSelect').disable(); // Disable period select
                } else {
                    // Update type lock based on other conditions
                    if (text[0].IsActivateUnderReview === 'A') {
                        $$('typeLock').setValue('Under_revision');
                    } else if (text[0].IsActivateAgainCharges === 'A') {
                        $$('typeLock').setValue('Counter_charges');
                    } else if (text[0].IsActivateSelftExclusion === 'A') {
                        $$('typeLock').setValue('Self_exclusion');
                    } else if (text[0].IsActivateRider === 'A') {
                        $$('typeLock').setValue('Rider');
                    } else if (text[0].IsActivateFraud === 'A') {
                        $$('typeLock').setValue('Fraud');
                    } else if (text[0].IsActivateAbusadorBonos === 'A') {
                        $$('typeLock').setValue('Abuse_bonuses');
                    }

                    // Handle date range selection
                    if (
                        text[0].startDate !== null &&
                        text[0].startDate !== '' &&
                        text[0].endDate !== null &&
                        text[0].endDate !== ''
                    ) {
                        $$('periodSelect').setValue('Rango personalizado');
                        let startDate = new Date(text[0].startDate * 1000);
                        let endDate = new Date(text[0].endDate * 1000);
                        let startFormatted = webix.Date.dateToStr('%Y-%m-%d %H:%i:%s')(startDate);
                        let endFormatted = webix.Date.dateToStr('%Y-%m-%d %H:%i:%s')(endDate);
                        $$('Period').setValue({
                            start: startFormatted,
                            end: endFormatted,
                        });
                    } else if (text[0].startDate === '' && text[0].endDate === '') {
                        $$('periodSelect').setValue('Indefinido');
                        $$('Period').setValue({
                            start: moment().subtract(0, 'days').format('YYYY-MM-DD'),
                            end: moment().format('YYYY-MM-DD'),
                        });
                    } else {
                        $$('Period').setValue({
                            start: moment().subtract(0, 'days').format('YYYY-MM-DD'),
                            end: moment().format('YYYY-MM-DD'),
                        });
                    }
                    $$('Period').enable(); // Enable period field
                    $$('periodSelect').enable(); // Enable period select
                }

                // Set the contingency comment if available
                if (text[0].Comment) {
                    $$('contingencyComment').setValue(text[0].Comment);
                } else {
                    $$('contingencyComment').setValue('');
                }

                // Handle comment history
                if (text[0].CommentHistory.length > 0) {
                    text[0].CommentHistory = text[0].CommentHistory.map((comment) => {
                        return {
                            date:
                                comment.startDate !== null && comment.startDate !== ''
                                    ? webix.Date.dateToStr('%Y-%m-%d %H:%i:%s')(new Date(comment.startDate))
                                    : 'No definida',
                            comment: comment.CommentHistory,
                        };
                    });
                    this.commentHistory = text[0].CommentHistory; // Store comment history
                    $$('viewComments').show(); // Show comments view
                } else {
                    this.commentHistory = [];
                    $$('viewComments').hide(); // Hide comments view
                }
            },
        });

        // Fetch types of blocks
        webix.ajax().get(devConfig.geturlApi() + 'Client/GetTypesBlock', {
            error: function (text, data, XmlHttpRequest) {
                webix.message({
                    title: _('¡Mensaje!'),
                    type: 'alert-error',
                    text: _('Ocurrio un error.'),
                });
            },
            success: function (text, data, XmlHttpRequest) {
                text = JSON.parse(text); // Parse the response text
                let list = [
                    { value: text.Data.Name[0], id: 'Abuse_bonuses' },
                    { value: text.Data.Name[1], id: 'Fraud' },
                    { value: text.Data.Name[2], id: 'Rider' },
                    { value: text.Data.Name[3], id: 'Self_exclusion' },
                    { value: text.Data.Name[4], id: 'Counter_charges' },
                    { value: text.Data.Name[5], id: 'Under_revision' },
                    { value: text.Data.Name[6], id: 'Activated' },
                ];
                $$('typeLock').define('options', list); // Define options for type lock
                $$('typeLock').refresh(); // Refresh the type lock
            },
        });
    }

    /**
     * Configures the layout of the security form.
     * @returns {Object} The configuration object for the form.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Get the current theme
        const cur_user = this.getParam('user', true); // Get the current user ID
        return {
            view: 'form',
            css: theme, // Apply the theme
            id: 'formSecurity',
            elements: [
                {
                    cols: [
                        {
                            rows: [
                                { view: 'label', label: _('Tipo bloqueo') }, // Label for block type
                                {
                                    id: 'typeLock',
                                    name: 'TypeLock',
                                    view: 'radio',
                                    vertical: true,
                                    options: [
                                        {
                                            value: 'Usuario Abusador de bonos',
                                            id: 'Abuse_bonuses',
                                        },
                                        { value: 'Fraude', id: 'Fraud' },
                                        { value: 'Jineteo', id: 'Rider' },
                                        {
                                            value: 'Autoexclusion',
                                            id: 'Self_exclusion',
                                        },
                                        {
                                            value: 'Contra cargos',
                                            id: 'Counter_charges',
                                        },
                                        {
                                            value: 'Bajo revision',
                                            id: 'Under_revision',
                                        },
                                        { value: 'Activado', id: 'Activated' },
                                    ],
                                    click: function () {
                                        const value = this.getValue(); // Get the selected value
                                        if (value === 'Activated') {
                                            let checkboxes = [
                                                'StateContingencySwith',
                                                'StateContingencyDeportivasSwith',
                                                'StateContingencyCasinoSwith',
                                                'StateContingencyCasinoVivoSwith',
                                                'StateContingencyVirtualesSwith',
                                                'StateContingencyPokerSwith',
                                                'StateContingencyWithdrawalSwith',
                                                'StateContingencyDepositSwith',
                                            ];
                                            checkboxes.forEach((checkbox) => {
                                                $$(checkbox).disable(); // Disable checkboxes
                                                $$(checkbox).setValue(0); // Set checkbox value to 0
                                            });
                                            $$('Period').disable(); // Disable period field
                                            $$('Period').hide(); // Hide period field
                                            $$('periodSelect').setValue('Indefinido'); // Set period select to undefined
                                            $$('periodSelect').disable(); // Disable period select
                                            $$('remainingTime').setValue(''); // Clear remaining time
                                            $$('periodDuration').setValue(''); // Clear period duration
                                        } else {
                                            // Enable checkboxes if not activated
                                            $$('StateContingencySwith').enable();
                                            $$('StateContingencyDeportivasSwith').enable();
                                            $$('StateContingencyCasinoSwith').enable();
                                            $$('StateContingencyCasinoVivoSwith').enable();
                                            $$('StateContingencyVirtualesSwith').enable();
                                            $$('StateContingencyPokerSwith').enable();
                                            $$('StateContingencyWithdrawalSwith').enable();
                                            $$('StateContingencyDepositSwith').enable();
                                            $$('periodSelect').enable(); // Enable period select
                                        }
                                    },
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Tipo de contingencia'),
                                }, // Label for contingency type
                                {
                                    view: 'checkbox',
                                    id: 'StateContingencyDeportivasSwith',
                                    labelRight: 'Deportivas',
                                    labelWidth: 0,
                                    height: 50,
                                },
                                {
                                    view: 'checkbox',
                                    id: 'StateContingencySwith',
                                    labelRight: 'General',
                                    labelWidth: 0,
                                    height: 50,
                                },
                                {
                                    view: 'checkbox',
                                    id: 'StateContingencyCasinoSwith',
                                    labelRight: 'Casino',
                                    labelWidth: 0,
                                    height: 50,
                                },
                                {
                                    view: 'checkbox',
                                    id: 'StateContingencyCasinoVivoSwith',
                                    labelRight: 'Casino en vivo',
                                    labelWidth: 0,
                                    height: 50,
                                },
                                {
                                    view: 'checkbox',
                                    id: 'StateContingencyVirtualesSwith',
                                    labelRight: 'Virtuales',
                                    labelWidth: 0,
                                    height: 50,
                                },
                                {
                                    view: 'checkbox',
                                    id: 'StateContingencyPokerSwith',
                                    labelRight: 'Poker',
                                    labelWidth: 0,
                                    height: 50,
                                },
                                {
                                    view: 'checkbox',
                                    id: 'StateContingencyWithdrawalSwith',
                                    labelRight: 'Retiro',
                                    labelWidth: 0,
                                    height: 50,
                                },
                                {
                                    view: 'checkbox',
                                    id: 'StateContingencyDepositSwith',
                                    labelRight: 'Deposito',
                                    labelWidth: 0,
                                    height: 50,
                                },
                            ],
                        },
                    ],
                },
                {
                    cols: [
                        {
                            rows: [
                                {
                                    id: 'contingencyComment',
                                    name: 'Comment',
                                    view: 'textarea',
                                    label: 'Comentario', // Label for comment
                                    labelPosition: 'top',
                                    required: true,
                                    inputWidth: 400,
                                    inputHeight: 140,
                                },
                                {
                                    id: 'viewComments',
                                    view: 'button',
                                    label: 'Ver historial de comentarios', // Button to view comment history
                                    hidden: true,
                                    inputWidth: 400,
                                    click: () => {
                                        webix
                                            .ui({
                                                view: 'window',
                                                id: 'commentsWindow',
                                                position: 'center',
                                                width: 500,
                                                height: 500,
                                                modal: true,
                                                head: {
                                                    view: 'toolbar',
                                                    cols: [
                                                        {
                                                            view: 'label',
                                                            label: 'Historial de comentarios',
                                                        }, // Label for comment history window
                                                        {
                                                            view: 'button',
                                                            label: 'X',
                                                            width: 50,
                                                            align: 'right',
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close the window
                                                            },
                                                        },
                                                    ],
                                                },
                                                body: {
                                                    view: 'list',
                                                    id: 'commentsList',
                                                    type: {
                                                        height: function (obj) {
                                                            let lines = obj.comment.split('\n').length; // Calculate height based on comment lines
                                                            return lines * 10;
                                                        },
                                                    },
                                                    template: '<strong>#date#</strong> - #comment#', // Template for displaying comments
                                                    autoheight: false,
                                                    autowidth: false,
                                                    scroll: 'xy',
                                                    height: 350,
                                                    width: 450,
                                                    data: this.commentHistory, // Set comment history data
                                                },
                                            })
                                            .show(); // Show the comments window
                                    },
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    height: 150,
                                    rows: [
                                        {
                                            cols: [
                                                {
                                                    id: 'periodSelect',
                                                    view: 'combo',
                                                    label:
                                                        "<span class='webix_icon icon-calendar'></span>" +
                                                        _('Selecciona un periodo'), // Label for period selection
                                                    labelPosition: 'top',
                                                    options: [
                                                        'Día',
                                                        'Semana',
                                                        'Mes (30 dias)',
                                                        'Indefinido',
                                                        'Rango personalizado',
                                                    ],
                                                    inputWidth: 250,
                                                    required: true,
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            let now = new Date(); // Get current date
                                                            if (newv === 'Rango personalizado') {
                                                                $$('Period').enable(); // Enable period field
                                                                $$('Period').show(); // Show period field
                                                            } else {
                                                                let nowTimestamp = new Date().getTime();
                                                                switch (newv) {
                                                                    case 'Día':
                                                                        $$('Period').setValue({
                                                                            start: new Date(nowTimestamp),
                                                                            end: new Date(nowTimestamp + 86400000),
                                                                        });
                                                                        break;
                                                                    case 'Semana':
                                                                        $$('Period').setValue({
                                                                            start: new Date(nowTimestamp),
                                                                            end: new Date(nowTimestamp + 604800000),
                                                                        });
                                                                        break;
                                                                    case 'Mes (30 dias)':
                                                                        $$('Period').setValue({
                                                                            start: new Date(nowTimestamp),
                                                                            end: new Date(nowTimestamp + 2592000000),
                                                                        });
                                                                        break;
                                                                    case 'Indefinido':
                                                                        $$('Period').setValue({
                                                                            start: new Date(nowTimestamp),
                                                                            end: new Date(nowTimestamp),
                                                                        });
                                                                        break;
                                                                    default:
                                                                        break;
                                                                }
                                                                $$('Period').hide(); // Hide period field
                                                                $$('Period').disable(); // Disable period field
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    id: 'Period',
                                                    name: 'Period',
                                                    view: 'daterangepicker',
                                                    css: 'reportrange',
                                                    hidden: true,
                                                    value: {
                                                        start: moment().subtract(0, 'days').format('YYYY-MM-DD'),
                                                        end: moment().format('YYYY-MM-DD'),
                                                    },
                                                    label: _('Rango de fechas'), // Label for date range
                                                    labelPosition: 'top',
                                                    required: true,
                                                    placeholder: _('Click para seleccionar '),
                                                    format: '%Y-%m-%d %H:%i:%s',
                                                    timepicker: true,
                                                    on: {
                                                        onChange: function (newv, oldv) {
                                                            if (!newv.end) {
                                                                webix.message({
                                                                    type: 'error',
                                                                    text: 'La fecha final debe ser seleccionada', // Error message for end date
                                                                });
                                                                this.setValue(oldv); // Reset to old value
                                                            }
                                                            let start = new Date(newv.start);
                                                            let end = new Date(newv.end);
                                                            let periodDuration = end - start; // Calculate duration
                                                            let durationSeconds = Math.floor(
                                                                (periodDuration / 1000) % 60,
                                                            );
                                                            let durationMinutes = Math.floor(
                                                                (periodDuration / 1000 / 60) % 60,
                                                            );
                                                            let durationHours = Math.floor(
                                                                (periodDuration / (1000 * 60 * 60)) % 24,
                                                            );
                                                            let durationDays = Math.floor(
                                                                periodDuration / (1000 * 60 * 60 * 24),
                                                            );
                                                            if (periodDuration > 0) {
                                                                let durationString = 'Duración total: ';
                                                                if (durationDays > 0) {
                                                                    durationString +=
                                                                        durationDays +
                                                                        (durationDays > 1 ? ' días' : ' día');
                                                                }
                                                                if (durationHours > 0) {
                                                                    durationString +=
                                                                        (durationDays > 0 ? ', ' : '') +
                                                                        durationHours +
                                                                        (durationHours > 1 ? ' horas' : ' hora');
                                                                }
                                                                if (durationMinutes > 0) {
                                                                    durationString +=
                                                                        (durationHours > 0 ? ', ' : '') +
                                                                        durationMinutes +
                                                                        (durationMinutes > 1 ? ' minutos' : ' minuto');
                                                                }
                                                                if (durationSeconds > 0) {
                                                                    durationString +=
                                                                        (durationMinutes > 0 ? ', ' : '') +
                                                                        durationSeconds +
                                                                        (durationSeconds > 1
                                                                            ? ' segundos.'
                                                                            : ' segundo.');
                                                                }
                                                                $$('periodDuration').setValue(durationString); // Set duration label
                                                            } else {
                                                                $$('periodDuration').setValue(''); // Clear duration label
                                                            }
                                                            let now = new Date();
                                                            let start2 = new Date(newv.start);
                                                            let end2 = new Date(newv.end);
                                                            let remainingTimeStart = start2.getTime() - now.getTime();
                                                            let remainingTimeEnd = end2.getTime() - now.getTime();
                                                            let remaining =
                                                                remainingTimeStart > 0
                                                                    ? remainingTimeStart
                                                                    : remainingTimeEnd;
                                                            let remainingSeconds = Math.floor((remaining / 1000) % 60);
                                                            let remainingMinutes = Math.floor(
                                                                (remaining / 1000 / 60) % 60,
                                                            );
                                                            let remainingHours = Math.floor(
                                                                (remaining / (1000 * 60 * 60)) % 24,
                                                            );
                                                            let remainingDays = Math.floor(
                                                                remaining / (1000 * 60 * 60 * 24),
                                                            );
                                                            let durationString = '';
                                                            if (remainingDays > 0) {
                                                                durationString +=
                                                                    remainingDays +
                                                                    (remainingDays > 1 ? ' días' : ' día');
                                                            }
                                                            if (remainingHours > 0) {
                                                                durationString +=
                                                                    (remainingDays > 0 ? ', ' : '') +
                                                                    remainingHours +
                                                                    (remainingHours > 1 ? ' horas' : ' hora');
                                                            }
                                                            if (remainingMinutes > 0) {
                                                                durationString +=
                                                                    (remainingHours > 0 ? ', ' : '') +
                                                                    remainingMinutes +
                                                                    (remainingMinutes > 1 ? ' minutos' : ' minuto');
                                                            }
                                                            if (remainingSeconds > 0) {
                                                                durationString +=
                                                                    (remainingMinutes > 0 ? ', ' : '') +
                                                                    remainingSeconds +
                                                                    (remainingSeconds > 1 ? ' segundos.' : ' segundo.');
                                                            }
                                                            if (remainingTimeStart > 0) {
                                                                $$('remainingTime').setValue(
                                                                    'Inicia en: ' + durationString, // Set remaining time label
                                                                );
                                                            } else if (remainingTimeEnd > 0) {
                                                                $$('remainingTime').setValue(
                                                                    'Finaliza en: ' + durationString, // Set remaining time label
                                                                );
                                                            } else {
                                                                $$('remainingTime').setValue(''); // Clear remaining time label
                                                            }
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            id: 'periodDuration',
                                            view: 'label',
                                            label: '',
                                            height: 30,
                                            css: 'period-duration', // CSS class for period duration label
                                        },
                                        {
                                            id: 'remainingTime',
                                            view: 'label',
                                            label: '',
                                            height: 30,
                                            css: {
                                                'font-size': '1em',
                                                'font-weight': 'bold', // CSS for remaining time label
                                            },
                                        },
                                    ],
                                },
                                {
                                    height: 50,
                                    cols: [
                                        {
                                            view: 'button',
                                            id: 'button_cancel',
                                            value: 'Limpiar', // Clear button
                                            css: 'webix_secondary',
                                            align: 'center',
                                            inputHeight: 50,
                                            inputWidth: 150,
                                            click: () => {
                                                $$('contingencyComment').setValue(''); // Clear comment
                                                $$('typeLock').setValue(''); // Clear type lock
                                                $$('periodSelect').setValue(''); // Clear period select
                                                $$('Period').setValue({
                                                    start: moment().subtract(0, 'days').format('YYYY-MM-DD'),
                                                    end: moment().format('YYYY-MM-DD'),
                                                }); // Reset date range
                                                $$('Period').hide(); // Hide period field
                                                $$('remainingTime').setValue(''); // Clear remaining time
                                                $$('periodDuration').setValue(''); // Clear period duration
                                                let checkboxes = [
                                                    'StateContingencySwith',
                                                    'StateContingencyDeportivasSwith',
                                                    'StateContingencyCasinoSwith',
                                                    'StateContingencyCasinoVivoSwith',
                                                    'StateContingencyVirtualesSwith',
                                                    'StateContingencyPokerSwith',
                                                    'StateContingencyWithdrawalSwith',
                                                    'StateContingencyDepositSwith',
                                                ];
                                                checkboxes.forEach((checkbox) => {
                                                    $$(checkbox).disable(); // Disable checkboxes
                                                    $$(checkbox).setValue(0); // Set checkbox value to 0
                                                });
                                                $$('Period').disable(); // Disable period field
                                                $$('periodSelect').disable(); // Disable period select
                                            },
                                        },
                                        {
                                            view: 'button',
                                            id: 'button_save',
                                            value: 'Guardar', // Save button
                                            css: 'webix_primary',
                                            align: 'center',
                                            inputHeight: 50,
                                            inputWidth: 150,
                                            click: () => {
                                                $$('button_save').disable(); // Disable save button
                                                let contingency = $$('typeLock').getValue(); // Get selected contingency type
                                                if (contingency === '') {
                                                    webix.message({
                                                        title: _('¡Mensaje!'),
                                                        type: 'alert-error',
                                                        text: _('El tipo de bloqueo es obligatorio.'), // Error message for missing type lock
                                                    });
                                                    $$('button_save').enable(); // Enable save button
                                                    return;
                                                }
                                                let values = $$('contingencyComment').getValue(); // Get comment value
                                                if (values === '') {
                                                    webix.message({
                                                        title: _('¡Mensaje!'),
                                                        type: 'alert-error',
                                                        text: _('El comentario es obligatorio.'), // Error message for missing comment
                                                    });
                                                    $$('button_save').enable(); // Enable save button
                                                    return;
                                                }
                                                let periodValue = $$('Period').getValue(); // Get period value
                                                let startTimestamp = new Date(periodValue.start).getTime(); // Convert start date to timestamp
                                                let endTimestamp = new Date(periodValue.end).getTime(); // Convert end date to timestamp
                                                let nowTimestamp = new Date().getTime();
                                                switch ($$('periodSelect').getValue()) {
                                                    case 'Día':
                                                        startTimestamp = nowTimestamp; // Set start timestamp for day
                                                        endTimestamp = nowTimestamp + 86400000; // Set end timestamp for day
                                                        break;
                                                    case 'Semana':
                                                        startTimestamp = nowTimestamp; // Set start timestamp for week
                                                        endTimestamp = nowTimestamp + 604800000; // Set end timestamp for week
                                                        break;
                                                    case 'Mes (30 dias)':
                                                        startTimestamp = nowTimestamp; // Set start timestamp for month
                                                        endTimestamp = nowTimestamp + 2592000000; // Set end timestamp for month
                                                        break;
                                                    case 'Indefinido':
                                                        startTimestamp = nowTimestamp; // Set start timestamp for undefined
                                                        endTimestamp = nowTimestamp; // Set end timestamp for undefined
                                                        break;
                                                    case 'Rango personalizado':
                                                        break; // Custom range, no change needed
                                                    default:
                                                        break;
                                                }
                                                if (startTimestamp < nowTimestamp) {
                                                    webix.message({
                                                        title: _('¡Mensaje!'),
                                                        type: 'alert-error',
                                                        text: _(
                                                            'La fecha de inicio no puede ser menor a la fecha actual.', // Error message for invalid start date
                                                        ),
                                                    });
                                                    $$('button_save').enable(); // Enable save button
                                                    return;
                                                }
                                                let newValue = {
                                                    ClientId: cur_user, // Set client ID
                                                    Comment: values, // Set comment
                                                    startDate: startTimestamp, // Set start date
                                                    endDate: endTimestamp, // Set end date
                                                };
                                                newValue[contingency] = 1; // Set contingency value
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/UpdateUserSecurity2',
                                                        newValue,
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message({
                                                                    title: _('¡Mensaje!'),
                                                                    type: 'alert-error',
                                                                    text: _('Ocurrio un error.'), // Error message for AJAX error
                                                                });
                                                                $$('button_save').enable(); // Enable save button
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                text = JSON.parse(text); // Parse response text
                                                                if (text.HasError) {
                                                                    if (text.CodeError === 300022) {
                                                                        webix.message({
                                                                            title: _('¡Mensaje!'),
                                                                            type: 'alert-error',
                                                                            text: _(
                                                                                'No se permite aplicar contingencia sin comentario', // Error message for missing comment
                                                                            ),
                                                                        });
                                                                    } else if (text.CodeError === 300021) {
                                                                        webix.message({
                                                                            title: _('¡Mensaje!'),
                                                                            type: 'alert-error',
                                                                            text: _(
                                                                                'No se permite aplicar contingencia sin periodo', // Error message for missing period
                                                                            ),
                                                                        });
                                                                    } else {
                                                                        webix.message({
                                                                            title: _('¡Mensaje!'),
                                                                            type: 'alert-error',
                                                                            text: _(
                                                                                'Ocurrio un error al aplicar la contingencia', // Error message for applying contingency
                                                                            ),
                                                                        });
                                                                    }
                                                                } else {
                                                                    webix.alert({
                                                                        title: 'Notificación',
                                                                        text: _(
                                                                            'La contingencia ha sido ' +
                                                                                (contingency === 'Activated'
                                                                                    ? 'desactivada'
                                                                                    : 'activada') +
                                                                                ' correctamente.', // Success message for applying contingency
                                                                        ),
                                                                    });
                                                                }
                                                                $$('button_save').enable(); // Enable save button
                                                            },
                                                        },
                                                    );

                                                // Handle updates for various types of contingencies
                                                let typesContingencyActivate =
                                                    webix.storage.local.get('typesContingency');
                                                let newValues = {
                                                    Action: '',
                                                    Id: cur_user,
                                                    IsActivate: '',
                                                    startDate: startTimestamp,
                                                    endDate: endTimestamp,
                                                };
                                                if (
                                                    typesContingencyActivate['StateContingencyDepositSwith'] !==
                                                    $$('StateContingencyDepositSwith').getValue()
                                                ) {
                                                    let depositContingencyState =
                                                        $$('StateContingencyDepositSwith').getValue() === 1 ? 'A' : 'I';
                                                    newValues.IsActivate = depositContingencyState;
                                                    newValues.Action = 'ContingencyDeposit';
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                                            newValues,
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message({
                                                                        title: _('¡Mensaje!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error - Contingencia Deposito', // Error message for deposit contingency
                                                                        ),
                                                                    });
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        _(
                                                                            'Contingencia Deposito ' +
                                                                                depositContingencyState ===
                                                                                'A'
                                                                                ? 'Activada'
                                                                                : 'Desactivada', // Success message for deposit contingency
                                                                        ),
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    typesContingencyActivate = {
                                                        ...typesContingencyActivate,
                                                        StateContingencyDepositSwith:
                                                            depositContingencyState === 'A' ? 1 : 0,
                                                    };
                                                }
                                                if (
                                                    typesContingencyActivate['StateContingencyWithdrawalSwith'] !==
                                                    $$('StateContingencyWithdrawalSwith').getValue()
                                                ) {
                                                    let withdrawalContingencyState =
                                                        $$('StateContingencyWithdrawalSwith').getValue() === 1
                                                            ? 'A'
                                                            : 'I';
                                                    newValues.IsActivate = withdrawalContingencyState;
                                                    newValues.Action = 'ContingencyWithdrawal';
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                                            newValues,
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message({
                                                                        title: _('¡Mensaje!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error - Contingencia Retiros', // Error message for withdrawal contingency
                                                                        ),
                                                                    });
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        _(
                                                                            'Contingencia Retiros ' +
                                                                                withdrawalContingencyState ===
                                                                                'A'
                                                                                ? 'Activada'
                                                                                : 'Desactivada', // Success message for withdrawal contingency
                                                                        ),
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    typesContingencyActivate = {
                                                        ...typesContingencyActivate,
                                                        StateContingencyWithdrawalSwith:
                                                            withdrawalContingencyState === 'A' ? 1 : 0,
                                                    };
                                                }
                                                if (
                                                    typesContingencyActivate['StateContingencyPokerSwith'] !==
                                                    $$('StateContingencyPokerSwith').getValue()
                                                ) {
                                                    let pokerContingencyState =
                                                        $$('StateContingencyPokerSwith').getValue() === 1 ? 'A' : 'I';
                                                    newValues.IsActivate = pokerContingencyState;
                                                    newValues.Action = 'ContingencyPoker';
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                                            newValues,
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message({
                                                                        title: _('¡Mensaje!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error - Contingencia Poker', // Error message for poker contingency
                                                                        ),
                                                                    });
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        _(
                                                                            'Contingencia Poker ' +
                                                                                pokerContingencyState ===
                                                                                'A'
                                                                                ? 'Activada'
                                                                                : 'Desactivada', // Success message for poker contingency
                                                                        ),
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    typesContingencyActivate = {
                                                        ...typesContingencyActivate,
                                                        StateContingencyPokerSwith:
                                                            pokerContingencyState === 'A' ? 1 : 0,
                                                    };
                                                }
                                                if (
                                                    typesContingencyActivate['StateContingencyVirtualesSwith'] !==
                                                    $$('StateContingencyVirtualesSwith').getValue()
                                                ) {
                                                    let virtualesContingencyState =
                                                        $$('StateContingencyVirtualesSwith').getValue() === 1
                                                            ? 'A'
                                                            : 'I';
                                                    newValues.IsActivate = virtualesContingencyState;
                                                    newValues.Action = 'ContingencyVirtuales';
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                                            newValues,
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message({
                                                                        title: _('¡Mensaje!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error - Contingencia Virtuales', // Error message for virtual contingency
                                                                        ),
                                                                    });
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        _(
                                                                            'Contingencia Virtuales ' +
                                                                                virtualesContingencyState ===
                                                                                'A'
                                                                                ? 'Activada'
                                                                                : 'Desactivada', // Success message for virtual contingency
                                                                        ),
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    typesContingencyActivate = {
                                                        ...typesContingencyActivate,
                                                        StateContingencyVirtualesSwith:
                                                            virtualesContingencyState === 'A' ? 1 : 0,
                                                    };
                                                }
                                                if (
                                                    typesContingencyActivate['StateContingencyCasinoVivoSwith'] !==
                                                    $$('StateContingencyCasinoVivoSwith').getValue()
                                                ) {
                                                    let casinoVivoContingencyState =
                                                        $$('StateContingencyCasinoVivoSwith').getValue() === 1
                                                            ? 'A'
                                                            : 'I';
                                                    newValues.IsActivate = casinoVivoContingencyState;
                                                    newValues.Action = 'ContingencyCasinoVivo';
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                                            newValues,
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message({
                                                                        title: _('¡Mensaje!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error - Contingencia Casino Vivo', // Error message for live casino contingency
                                                                        ),
                                                                    });
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        _(
                                                                            'Contingencia Casino Vivo ' +
                                                                                casinoVivoContingencyState ===
                                                                                'A'
                                                                                ? 'Activada'
                                                                                : 'Desactivada', // Success message for live casino contingency
                                                                        ),
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    typesContingencyActivate = {
                                                        ...typesContingencyActivate,
                                                        StateContingencyCasinoVivoSwith:
                                                            casinoVivoContingencyState === 'A' ? 1 : 0,
                                                    };
                                                }
                                                if (
                                                    typesContingencyActivate['StateContingencyCasinoSwith'] !==
                                                    $$('StateContingencyCasinoSwith').getValue()
                                                ) {
                                                    let casinoContingencyState =
                                                        $$('StateContingencyCasinoSwith').getValue() === 1 ? 'A' : 'I';
                                                    newValues.IsActivate = casinoContingencyState;
                                                    newValues.Action = 'ContingencyCasino';
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                                            newValues,
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message({
                                                                        title: _('¡Mensaje!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error - Contingencia Casino', // Error message for casino contingency
                                                                        ),
                                                                    });
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        _(
                                                                            'Contingencia Casino ' +
                                                                                casinoContingencyState ===
                                                                                'A'
                                                                                ? 'Activada'
                                                                                : 'Desactivada', // Success message for casino contingency
                                                                        ),
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    typesContingencyActivate = {
                                                        ...typesContingencyActivate,
                                                        StateContingencyCasinoSwith:
                                                            casinoContingencyState === 'A' ? 1 : 0,
                                                    };
                                                }
                                                if (
                                                    typesContingencyActivate['StateContingencyDeportivasSwith'] !==
                                                    $$('StateContingencyDeportivasSwith').getValue()
                                                ) {
                                                    let deportivasContingencyState =
                                                        $$('StateContingencyDeportivasSwith').getValue() === 1
                                                            ? 'A'
                                                            : 'I';
                                                    newValues.IsActivate = deportivasContingencyState;
                                                    newValues.Action = 'ContingencySports';
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                                            newValues,
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message({
                                                                        title: _('¡Mensaje!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error - Contingencia Deportivas', // Error message for sports contingency
                                                                        ),
                                                                    });
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        _(
                                                                            'Contingencia Deportivas ' +
                                                                                deportivasContingencyState ===
                                                                                'A'
                                                                                ? 'Activada'
                                                                                : 'Desactivada', // Success message for sports contingency
                                                                        ),
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    typesContingencyActivate = {
                                                        ...typesContingencyActivate,
                                                        StateContingencyDeportivasSwith:
                                                            deportivasContingencyState === 'A' ? 1 : 0,
                                                    };
                                                }
                                                if (
                                                    typesContingencyActivate['StateContingencySwith'] !==
                                                    $$('StateContingencySwith').getValue()
                                                ) {
                                                    let generalContingencyState =
                                                        $$('StateContingencySwith').getValue() === 1 ? 'A' : 'I';
                                                    newValues.IsActivate = generalContingencyState;
                                                    newValues.Action = 'Contingency';
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                                            newValues,
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message({
                                                                        title: _('¡Mensaje!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error - Contingencia General', // Error message for general contingency
                                                                        ),
                                                                    });
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        _(
                                                                            'Contingencia General ' +
                                                                                generalContingencyState ===
                                                                                'A'
                                                                                ? 'Activada'
                                                                                : 'Desactivada', // Success message for general contingency
                                                                        ),
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    typesContingencyActivate = {
                                                        ...typesContingencyActivate,
                                                        StateContingencySwith: generalContingencyState === 'A' ? 1 : 0,
                                                    };
                                                }
                                                webix.storage.local.put('typesContingency', typesContingencyActivate); // Store updated types of contingency
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the security form by fetching the necessary data.
     */
    init() {
        this.getData(); // Fetch data on initialization
    }
}

// FILE DOCUMENTED
